import { CharacterCard } from '../types';

// メモリ上のカードキャッシュ（ページ遷移間のデータ受け渡し用）
let cachedCards: Map<string, CharacterCard> = new Map();

export const setCardCache = (card: CharacterCard) => {
  cachedCards.set(card.id, card);
};

export const getCardCache = (cardId: string): CharacterCard | null => {
  return cachedCards.get(cardId) || null;
};

export const setCardsCache = (cards: CharacterCard[]) => {
  cards.forEach(card => cachedCards.set(card.id, card));
};

export const clearCardCache = () => {
  cachedCards.clear();
};

// フィード一覧の状態キャッシュ（詳細ページから戻った時に再取得せず即時復元するため）
let feedCache: { allCards: CharacterCard[]; fetchedMonths: string[] } | null = null;

export const setFeedCache = (allCards: CharacterCard[], fetchedMonths: string[]) => {
  feedCache = { allCards, fetchedMonths };
};

export const getFeedCache = () => feedCache;
